var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCanSodaIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Can_Soda_icon_svg__clip0_1_38)",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M575.107 646.095H424.881c-45.261 0-81.953 36.692-81.953 81.953S379.62 810 424.881 810h150.226c45.261 0 81.952-36.691 81.952-81.952 0-45.261-36.691-81.953-81.952-81.953z",
    fill: "#95C2C7",
    stroke: "#4ABAC7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.238 288.262H405.762c-45.261 0-81.952 36.691-81.952 81.952v312.31c0 45.261 36.691 81.952 81.952 81.952h188.476c45.261 0 81.953-36.691 81.953-81.952v-312.31c0-45.261-36.692-81.952-81.953-81.952z",
    fill: "#FA505E",
    stroke: "#F93444",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.119 408.452H424.881c-45.072 0-81.953-36.881-81.953-81.952v-54.56h314.131v54.56c0 45.071-36.881 81.952-81.952 81.952h.012z",
    fill: "#95C2C7",
    stroke: "#4ABAC7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.119 353.905H424.881c-45.072 0-81.953-36.881-81.953-81.953 0-45.071 36.881-81.952 81.953-81.952h150.238c45.071 0 81.952 36.881 81.952 81.952 0 45.072-36.881 81.953-81.952 81.953z",
    fill: "#CAE0E3",
    stroke: "#95C2C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.071 271.952c0 45.072-36.881 81.953-81.952 81.953H424.881c-45.072 0-81.953-36.881-81.953-81.953",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.929 251.012h-62.834c-11.565 0-20.94 9.375-20.94 20.94 0 11.566 9.375 20.941 20.94 20.941h62.834c11.565 0 20.94-9.375 20.94-20.941 0-11.565-9.375-20.94-20.94-20.94z",
    fill: "#006C78",
    stroke: "#006C78",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.405 246.786h-75.488c-13.893 0-25.155 11.262-25.155 25.155v.011c0 13.893 11.262 25.155 25.155 25.155h75.488c13.892 0 25.155-11.262 25.155-25.155v-.011c0-13.893-11.263-25.155-25.155-25.155z",
    fill: "#CAE0E3",
    stroke: "#95C2C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.143 505.75v94.238c-90.691-52.345-173.631 63.964-264.286 11.643v-94.238c90.655 52.321 173.595-63.988 264.286-11.643z",
    fill: "#fff",
    stroke: "#CAE0E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.583 271.952c0-13.892-11.262-25.166-25.166-25.166h-12.5c-13.834 0-25.155 11.321-25.155 25.155 0 13.833 11.321 25.166 25.155 25.166h12.5c13.893 0 25.166-11.262 25.166-25.166v.011z",
    fill: "#CAE0E3",
    stroke: "#95C2C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Can_Soda_icon_svg__clip0_1_38"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanSodaIcon);
export default ForwardRef;